"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseSchema_1 = require("../baseSchema");
const baseViewSchema_1 = require("../baseSchema/baseViewSchema");
class ViewContentCreateSchema extends baseViewSchema_1.BaseViewSchema {
    constructor({ arrivedFrom, pageType }) {
        super({ arrivedFrom });
        this.action = baseSchema_1.ActionsName.VIEW_CONTENT_CREATE;
        this.pageType = pageType;
        this.concept = 'OLD';
    }
    getDataHubEventData() {
        return {
            ...super.prepare(),
            action: this.action,
            pageType: this.pageType,
            concept: this.concept
        };
    }
}
exports.default = ViewContentCreateSchema;
